import { Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Menu } from "lucide-react";
import { motion } from "framer-motion";

import Sidebar from "../components/Sidebar";
import Home from "./home";
import Header from "../components/reuseable/header";
import UserDetail from "./user-detail";
import EventMasterList from "./event-master-list";
import EventMasterDetail from "./event-master-detail";
import RoleManagment from "./role-managment";
import MainContent from "../components/content-review/main-content";
import DetailContent from "./detail-content";
import Announcements from "./announcement";
import AnnouncementDetail from "./announcement-detail";
import Compliance from "./compliance";
import AuditsLogs from "./audit-logs";
import AnalyticsReports from "./analytics-report";
import ApproveUsers from "../components/user-approval/approve-users";
import AllNonProfitUsers from "../components/user-approval/all-nonprofit-users";
import AllPinUsers from "../components/user-approval/all-pin-users";
import AdminInquiriesPage from "./admin-inquiries";
import AdminInquiryDetailPage from "./admin-inquiry-detail";
import GetInTouchQueriesPage from "./get-in-touch-queries";
import { FetchAllAdminInquiries } from "../Store/Actions/AdminInquiryActions";

function Dashboard() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapseBar, setIsCollapseBar] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginSuccess = useSelector((state) => state.auth?.loginSuccess);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getCollpase = (value) => {
    setIsCollapseBar(value);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
      setIsMobileMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Authentication check - redirect to login if not authenticated
  useEffect(() => {
    const checkAuth = () => {
      // Check both Redux state and localStorage as fallback
      const hasReduxAuth = loginSuccess && loginSuccess.data;
      const hasLocalStorageAuth = localStorage.getItem("loginSuccess") && localStorage.getItem("accessToken");
      
      if (!hasReduxAuth && !hasLocalStorageAuth) {
        // Clear any stale data
        localStorage.removeItem("loginSuccess");
        localStorage.removeItem("accessToken");
        // Redirect to login
        navigate("/", { replace: true });
      }
    };

    checkAuth();
  }, [loginSuccess, navigate]);

  // Pre-fetch inquiry count for sidebar badge
  useEffect(() => {
    const hasAuth = (loginSuccess && loginSuccess.data) || localStorage.getItem("accessToken");
    if (hasAuth) {
      dispatch(FetchAllAdminInquiries());
    }
  }, [dispatch, loginSuccess]);

  return (
    <div className="flex lg:flex-row flex-col w-full">
      <div className={`${isCollapseBar ? "lg:w-[5.5%]" : "lg:w-[24%]"}`}>
        <button
          className={`fixed top-3 left-4 z-50 ${
            isMobileMenuOpen ? "hidden" : ""
          } lg:hidden bg-gray-300 p-2 rounded-full`}
          onClick={toggleMobileMenu}
        >
          <Menu className="h-6 w-6" />
        </button>
        <Sidebar
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          isCollapse={getCollpase}
        />
      </div>
      <motion.div
        initial={{ x: 0 }}
        animate={isLargeScreen && isCollapseBar ? { x: 0 } : {}}
        transition={{ type: "spring", stiffness: 260, damping: 30 }}
        className={`${
          isCollapseBar ? " w-full" : "lg:w-[76%] w-full"
        }  overflow-y-auto}`}
      >
        <Header clases={"px-7"}/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/user-approval" element={<ApproveUsers />} />
          <Route path="/users/approve-users" element={<ApproveUsers />} />
          <Route path="/users/nonprofit-users" element={<AllNonProfitUsers />} />
          <Route path="/users/pin-users" element={<AllPinUsers />} />
          <Route path="/user-detail/:id" element={<UserDetail />} />
          <Route path="/event-master-list" element={<EventMasterList />} />
          <Route path="/event-master-detail/:id" element={<EventMasterDetail />} />
          <Route path="/role-managment" element={<RoleManagment />} />
          <Route path="/content-review" element={<MainContent />} />
          <Route path="/content-review-detail/:id" element={<DetailContent />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/announcements-detail/:id" element={<AnnouncementDetail />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/audit-logs" element={<AuditsLogs />} />
          <Route path="/analytics-report" element={<AnalyticsReports />} />
          <Route path="/admin-inquiries" element={<AdminInquiriesPage />} />
          <Route path="/admin-inquiries/:id" element={<AdminInquiryDetailPage />} />
          <Route path="/get-in-touch-queries" element={<GetInTouchQueriesPage />} />
        </Routes>
      </motion.div>
    </div>
  );
}

export default Dashboard;
